import { Map } from "@vis.gl/react-google-maps";
import type { MapMouseEvent } from "@vis.gl/react-google-maps";
import React from "react";

/** Same map ID as MissionMap for consistent styling. */
const MAP_ID = "aeb6dd73292717b9d8b403f4";

export interface GenericMapProps {
  /** Center (controlled). Use with zoom for full control. */
  center?: google.maps.LatLngLiteral;
  /** Initial center when uncontrolled. */
  defaultCenter?: google.maps.LatLngLiteral;
  /** Zoom level (controlled). */
  zoom?: number;
  /** Initial zoom when uncontrolled. */
  defaultZoom?: number;
  minZoom?: number;
  maxZoom?: number;
  /** Restrict map to a region (e.g. Israel bounds). */
  restriction?: {
    latLngBounds: google.maps.LatLngBoundsLiteral;
    strictBounds?: boolean;
  };
  /** Called when the map is clicked. detail.latLng is the clicked point. */
  onClick?: (event: MapMouseEvent) => void;
  /** Container style (e.g. height/width). */
  style?: React.CSSProperties;
  /** Map controls – match MissionMap defaults where relevant. */
  mapTypeControl?: boolean;
  streetViewControl?: boolean;
  fullscreenControl?: boolean;
  children?: React.ReactNode;
}

/**
 * Generic map wrapper around @vis.gl/react-google-maps Map.
 * Must be used inside APIProvider (e.g. from AppRoutes or wrapped in MapPinDialog).
 */
const GenericMap: React.FC<GenericMapProps> = ({
  center,
  defaultCenter,
  zoom,
  defaultZoom,
  minZoom = 7,
  maxZoom = 20,
  restriction,
  onClick,
  style = { width: "100%", height: "100%" },
  mapTypeControl = false,
  streetViewControl = false,
  fullscreenControl = false,
  children,
  ...mapProps
}) => {
  return (
    <Map
      mapId={MAP_ID}
      center={center}
      defaultCenter={defaultCenter}
      zoom={zoom}
      defaultZoom={defaultZoom}
      minZoom={minZoom}
      maxZoom={maxZoom}
      mapTypeControl={mapTypeControl}
      streetViewControl={streetViewControl}
      fullscreenControl={fullscreenControl}
      restriction={restriction}
      onClick={onClick}
      style={style}
      {...mapProps}
    >
      {children}
    </Map>
  );
};

export default GenericMap;
